module.exports = __webpack_public_path__ + "static/media/blocklytics-cool.b85f30ef.png";